import { render } from "./PageSubTitle.vue?vue&type=template&id=310c0ce6&scoped=true"
import script from "./PageSubTitle.vue?vue&type=script&lang=js"
export * from "./PageSubTitle.vue?vue&type=script&lang=js"

import "./PageSubTitle.vue?vue&type=style&index=0&id=310c0ce6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-cube_opr\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-310c0ce6"]])

export default __exports__